import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=ed8cc700&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"
import style0 from "./SystemConfig.vue?vue&type=style&index=0&id=ed8cc700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8cc700",
  null
  
)

export default component.exports